import SendSummary from './SendSummary';

export default SendSummary;